import PropTypes from 'prop-types';
import React from 'react';
import { StakeholderProfileLink } from '../../links/index.jsx';
import Tabs from '../../Tabs.jsx';

const StakeholderProfileTabs = ({ projectId, stakeholderId, slug }) => (
  <Tabs>
    <Tabs.Tab label="Overview">
      <StakeholderProfileLink
        projectId={projectId}
        stakeholderId={stakeholderId}
      />
    </Tabs.Tab>
  </Tabs>
);

StakeholderProfileTabs.propsTypes = {
  // project: PropTypes.shape({
  //   id: PropTypes.number.isRequired,
  // }).isRequired,
  projectId: PropTypes.number.isRequired,
  stakeholderId: PropTypes.number.isRequired,
};

export default StakeholderProfileTabs;
